import React from 'react';
import {
  Box,
  Button,
  Heading,
  Icon,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MdCheckCircle } from 'react-icons/md';
import Container from '../ui/Container';
import companyImage from '../../img/revisando-960.webp';

const POINTS = [
  {
    title: 'Experiencia',
    text: 'Soluciones eléctricas adaptadas a cada proyecto.',
  },
  {
    title: 'Equipo especializado',
    text: 'Ventas, proyectos, logística y administración.',
  },
  {
    title: 'Compromiso',
    text: 'Calidad, eficiencia y atención personalizada en cada etapa.',
  },
];

export default function CorporateIntro() {
  return (
    <Box as="section" py={{ base: 14, md: 20 }}>
      <Container>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 10, lg: 16 }}
          alignItems="center"
        >
          <Stack spacing={5}>
            <Heading as="h2" size="h2">
              Ingeniería, suministro e integración eléctrica
            </Heading>
            <Text color="text.secondary">
              En Soluciones Integraciones Eléctricas S.A. ofrecemos soluciones eléctricas adaptadas a las
              necesidades de cada cliente, con un servicio personalizado y de
              calidad como seña de identidad.
            </Text>
            <Text color="text.secondary">
              Nos dirigimos a la comercialización de materiales y equipos
              eléctricos para industria, comercio y construcción, con soluciones
              integrales y de valor agregado.
            </Text>
            <Stack spacing={4} pt={2}>
              {POINTS.map(point => (
                <Stack
                  key={point.title}
                  direction="row"
                  spacing={3}
                  align="flex-start"
                >
                  <Icon
                    as={MdCheckCircle}
                    color="accent.default"
                    boxSize={6}
                    mt={0.5}
                    flexShrink={0}
                    aria-hidden="true"
                  />
                  <Box>
                    <Text fontWeight={600}>{point.title}</Text>
                    <Text fontSize="sm" color="text.secondary">
                      {point.text}
                    </Text>
                  </Box>
                </Stack>
              ))}
            </Stack>
            <Button
              as={RouterLink}
              to="/about"
              variant="primary"
              alignSelf="flex-start"
              mt={2}
            >
              Conocer más sobre nosotros
            </Button>
          </Stack>

          <Image
            src={companyImage}
            alt="Técnicos de SIESA en una instalación eléctrica"
            borderRadius="lg"
            w="100%"
            h={{ base: '280px', lg: '460px' }}
            objectFit="cover"
            loading="lazy"
            decoding="async"
          />
        </SimpleGrid>
      </Container>
    </Box>
  );
}
